export const TRANS = {
  comingSoon: {
    en: 'Coming soon!',
    fi: 'Tulossa pian!',
  },
};
